<template>
  <div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Szczegóły
            </h4>
            <button class="close" type="button" @click="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" v-if="detailsData">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-5">Data:</div>
                  <div class="col-md-7">{{ details.date | datetime }}</div>
                </div>
                <div class="row">
                  <div class="col-md-5">Użytkownik:</div>
                  <div class="col-md-7">{{ details.userName }}</div>
                </div>
                <div class="row">
                  <div class="col-md-5">Obiekt:</div>
                  <div class="col-md-7">{{ details.userBranch }}</div>
                </div>
                <div class="row">
                  <div class="col-md-5">Zdarzenie</div>
                  <div class="col-md-7">{{ $t('logs.action.' + details.action) }}</div>
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'LOYALTYCARD_ADD'">
                  <div class="row">
                    <div class="col-md-5">{{ $t('loyaltyCards.cardType')}}</div>
                    <div class="col-md-7">
                      {{ $t('loyaltyCards.level.' + detailsData.cardType)}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">{{ $t('loyaltyCards.cardNumber')}}</div>
                    <div class="col-md-7">
                      {{ detailsData.cardNumber }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5"></div>
                    <div class="col-md-7">
                      <a href @click.prevent="goToClientDetails(detailsData.clientId)">Zobacz klienta</a>
                    </div>
                  </div>
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'TOGGLE_INVOICE_LOYALTY'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'CLIENT_MERGE'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'CLIENT_UPDATE'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'MANUAL_SYNC_APPROVE'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'MANUAL_SYNC_SPLIT'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'LOYALTYCARD_ADD_FAIL'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'LOYALTYCARD_ASSIGN_USER'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'LOYALTY_CARD_UPDATE_ACTIVE_STATUS'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'CLIENT_UPDATE_ACTIVE_STATUS'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'CLIENT_SEND_TO_PLAZA_SUCCESS'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'MANUAL_SYNC_APPROVE_FAIL'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'USER_CREATE'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'USER_CHANGEPASS'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'CLIENT_CONNECT'">
                  <!-- TODO -->
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'STAYS_REPORT_SUCCESS'">
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateFrom')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateFrom}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateTo')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateTo}}
                    </div>
                  </div>
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'STAYS_REPORT_ERROR'">
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateFrom')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateFrom}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateTo')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateTo}}
                    </div>
                  </div>
                </div>
                <!-- ############################################### -->
                <div v-if="details.action === 'STAYS_REPORT_REJECTED'">
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateFrom')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateFrom}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">{{ $t('stays.dateTo')}}</div>
                    <div class="col-md-7">
                      {{detailsData.dateTo}}
                    </div>
                  </div>
                </div>
                <!-- ############################################### -->
                <!--{{ detailsData }}-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  import { router } from '@Router';

  export default {
    data() {
      return {
        detailsData: null,
      };
    },
    props: [
      'details',
    ],
    mounted() {
      this.detailsData = JSON.parse(this.details.data);
    },
    methods: {
      goToClientDetails(clientId) {
        router.push({ name: 'clientDetails', params: { clientId } });
      },
      close() {
        this.$emit('closed');
      },
    },
  };
</script>
